import { Layout, TwoColumns, useSignupContext } from "Components";
import { Button } from "melodies-source/Button";
import { Body1, H4 } from "melodies-source/Text";
import verificationLinkImage from "assets/images/verification-link-email.jpg";
import { ReactComponent as HeadingIcon } from "assets/svg/verification-sent.svg";
import { styled } from "styled-components";
import { useIsMobile } from "melodies-source/utils/hooks";

export const VerificationLinkSent = () => {
  const { handleStart, lastEmail } = useSignupContext();
  const isMobile = useIsMobile();
  return (
    <Layout
      cardProps={{
        size: "large",
        heading: { icon: <HeadingIcon />, text: "Verification Sent" },
        actions: {
          buttons: (
            <Button
              variant="secondary"
              onClick={() => handleStart({ email: lastEmail })}
            >
              Resend
            </Button>
          ),
        },
      }}
    >
      <TwoColumns>
        <Container>
          <H4>Please check your email for a link to verify your account.</H4>
          <Body1>
            We’ve sent you a confirmation link through your email. Once that
            link is clicked, we will guide you to the next step in the process.
          </Body1>
          <Body1>
            If you didn’t receive the link, you can resend using the button
            below.
          </Body1>
        </Container>
        {!isMobile && (
          <ImageContainer>
            <VerificationEmailImage src={verificationLinkImage} />
          </ImageContainer>
        )}
      </TwoColumns>
    </Layout>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

const ImageContainer = styled.div`
  background-color: #f7fafc;
  border: 1px solid #ebebeb;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 65%;
  margin-top: -30px;
`;

const VerificationEmailImage = styled.img`
  width: 320px;
  height: 320px;
`;
